"use strict";
// Currency data from
// https://github.com/ourworldincode/currency/blob/main/currencies.json
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENCIES = exports.CurrencyCodes = void 0;
var CurrencyCodes;
(function (CurrencyCodes) {
    CurrencyCodes["UNITED_ARAB_EMIRATES_DIRHAM"] = "AED";
    CurrencyCodes["AFGHAN_AFGHANI"] = "AFN";
    CurrencyCodes["ALBANIAN_LEK"] = "ALL";
    CurrencyCodes["ARMENIAN_DRAM"] = "AMD";
    CurrencyCodes["NETHERLANDS_ANTILLEAN_GUILDER"] = "ANG";
    CurrencyCodes["ANGOLAN_KWANZA"] = "AOA";
    CurrencyCodes["ARGENTINE_PESO"] = "ARS";
    CurrencyCodes["AUSTRALIAN_DOLLAR"] = "AUD";
    CurrencyCodes["ARUBAN_FLORIN"] = "AWG";
    CurrencyCodes["AZERBAIJANI_MANAT"] = "AZN";
    CurrencyCodes["BOSNIA_AND_HERZEGOVINA_CONVERTIBLE_MARK"] = "BAM";
    CurrencyCodes["BARBADIAN_DOLLAR"] = "BBD";
    CurrencyCodes["BANGLADESHI_TAKA"] = "BDT";
    CurrencyCodes["BULGARIAN_LEV"] = "BGN";
    CurrencyCodes["BAHRAINI_DINAR"] = "BHD";
    CurrencyCodes["BURUNDIAN_FRANC"] = "BIF";
    CurrencyCodes["BERMUDIAN_DOLLAR"] = "BMD";
    CurrencyCodes["BRUNEI_DOLLAR"] = "BND";
    CurrencyCodes["BOLIVIAN_BOLIVIANO"] = "BOB";
    CurrencyCodes["BRAZILIAN_REAL"] = "BRL";
    CurrencyCodes["BAHAMIAN_DOLLAR"] = "BSD";
    CurrencyCodes["BHUTANESE_NGULTRUM"] = "BTN";
    CurrencyCodes["BOTSWANA_PULA"] = "BWP";
    CurrencyCodes["BELARUSIAN_RUBLE"] = "BYN";
    CurrencyCodes["BELIZE_DOLLAR"] = "BZD";
    CurrencyCodes["CANADIAN_DOLLAR"] = "CAD";
    CurrencyCodes["CONGOLESE_FRANC"] = "CDF";
    CurrencyCodes["SWISS_FRANC"] = "CHF";
    CurrencyCodes["COOK_ISLANDS_DOLLAR"] = "CKD";
    CurrencyCodes["CHILEAN_PESO"] = "CLP";
    CurrencyCodes["CHINESE_YUAN"] = "CNY";
    CurrencyCodes["COLOMBIAN_PESO"] = "COP";
    CurrencyCodes["COSTA_RICAN_COLON"] = "CRC";
    CurrencyCodes["CUBAN_CONVERTIBLE_PESO"] = "CUC";
    CurrencyCodes["CUBAN_PESO"] = "CUP";
    CurrencyCodes["CABO_VERDEAN_ESCUDO"] = "CVE";
    CurrencyCodes["CZECH_KORUNA"] = "CZK";
    CurrencyCodes["DJIBOUTIAN_FRANC"] = "DJF";
    CurrencyCodes["DANISH_KRONA"] = "DKK";
    CurrencyCodes["DOMINICAN_PESO"] = "DOP";
    CurrencyCodes["ALGERIAN_DINAR"] = "DZD";
    CurrencyCodes["EGYPTIAN_POUND"] = "EGP";
    CurrencyCodes["ERITREAN_NAKFA"] = "ERN";
    CurrencyCodes["ETHIOPIAN_BIRR"] = "ETB";
    CurrencyCodes["EURO"] = "EUR";
    CurrencyCodes["FIJIAN_DOLLAR"] = "FJD";
    CurrencyCodes["FALKLAND_ISLANDS_POUND"] = "FKP";
    CurrencyCodes["FAROESE_KRONA"] = "FOK";
    CurrencyCodes["POUND_STERLING"] = "GBP";
    CurrencyCodes["GEORGIAN_LARI"] = "GEL";
    CurrencyCodes["GUERNSEY_POUND"] = "GGP";
    CurrencyCodes["GHANIAN_CEDI"] = "GHS";
    CurrencyCodes["GIBRALTAR_POUND"] = "GIB";
    CurrencyCodes["GAMBIAN_DALASI"] = "GMD";
    CurrencyCodes["GUINEAN_FRANC"] = "GNF";
    CurrencyCodes["GUATEMALAN_QUETZAL"] = "GTQ";
    CurrencyCodes["GUYANESE_DOLLAR"] = "GYD";
    CurrencyCodes["HONG_KONG_DOLLAR"] = "HKD";
    CurrencyCodes["HONDURAN_LEMPIRA"] = "HNL";
    CurrencyCodes["CROATIAN_KUNA"] = "HRK";
    CurrencyCodes["HAITIAN_GOURDE"] = "HTG";
    CurrencyCodes["HUNGARIAN_FORINT"] = "HUF";
    CurrencyCodes["INDONESIAN_RUPIAH"] = "IDR";
    CurrencyCodes["ISRAELI_NEW_SHEKEL"] = "ILS";
    CurrencyCodes["MANX_POUND"] = "IMP";
    CurrencyCodes["INDIAN_RUPEE"] = "INR";
    CurrencyCodes["IRAQI_DINAR"] = "IQD";
    CurrencyCodes["IRANIAN_RIAL"] = "IRR";
    CurrencyCodes["ICELANDIC_KRONA"] = "ISK";
    CurrencyCodes["JERSEY_POUND"] = "JEP";
    CurrencyCodes["JAMAICAN_DOLLAR"] = "JMD";
    CurrencyCodes["JORDANIAN_DOLLAR"] = "JOD";
    CurrencyCodes["JAPANESE_YEN"] = "JPY";
    CurrencyCodes["KENYAN_SHILLING"] = "KES";
    CurrencyCodes["KYRGYZSTANI_SOM"] = "KGS";
    CurrencyCodes["CAMBODIAN_RIEL"] = "KHR";
    CurrencyCodes["KIRIBATI_DOLLAR"] = "KID";
    CurrencyCodes["COMORIAN_FRANC"] = "KMF";
    CurrencyCodes["NORTH_KOREAN_WON"] = "KPW";
    CurrencyCodes["SOUTH_KOREAN_WON"] = "KRW";
    CurrencyCodes["KUWAITI_DINAR"] = "KWD";
    CurrencyCodes["CAYMAN_ISLANDS_DOLLAR"] = "KYD";
    CurrencyCodes["KAZAKHSTANI_TENGE"] = "KZT";
    CurrencyCodes["LAO_KIP"] = "LAK";
    CurrencyCodes["LEBANESE_POUND"] = "LBP";
    CurrencyCodes["SRI_LANKAN_RUPEE"] = "LKR";
    CurrencyCodes["LIBERIAN_DOLLAR"] = "LRD";
    CurrencyCodes["LESOTHO_LOTI"] = "LSL";
    CurrencyCodes["LIBYAN_DINAR"] = "LYD";
    CurrencyCodes["MOROCCAN_DIRHAM"] = "MAD";
    CurrencyCodes["MOLDOVAN_LEU"] = "MDL";
    CurrencyCodes["MALAGASY_ARIARY"] = "MGA";
    CurrencyCodes["MACEDONIAN_DENAR"] = "MKD";
    CurrencyCodes["MYANMAR_KYAT"] = "MMK";
    CurrencyCodes["MONGOLIAN_TOGROG"] = "MNT";
    CurrencyCodes["MACANESE_PATACA"] = "MOP";
    CurrencyCodes["MAURITANIAN_OUGUIYA"] = "MRU";
    CurrencyCodes["MAURITANIAN_RUPEE"] = "MUR";
    CurrencyCodes["MALDIVIAN_RUFIYAA"] = "MVR";
    CurrencyCodes["MALAWIAN_KWACHA"] = "MWK";
    CurrencyCodes["MEXICAN_PESO"] = "MXN";
    CurrencyCodes["MALAYSIAN_RINGGIT"] = "MYR";
    CurrencyCodes["MOZAMBICAN_METICAL"] = "MZN";
    CurrencyCodes["NAMIBIAN_DOLLAR"] = "NAD";
    CurrencyCodes["NIGERIAN_NAIRA"] = "NGN";
    CurrencyCodes["NICARAGUAN_CORDOBA"] = "NIO";
    CurrencyCodes["NORWEGIAN_KRONA"] = "NOK";
    CurrencyCodes["NEPALESE_RUPEE"] = "NPR";
    CurrencyCodes["NEW_ZEALAND_DOLLAR"] = "NZD";
    CurrencyCodes["OMANI_RIAL"] = "OMR";
    CurrencyCodes["PANAMANIAN_BALBOA"] = "PAB";
    CurrencyCodes["PERUVIAN_SOL"] = "PEN";
    CurrencyCodes["PAPUA_NEW_GUINEAN_KINA"] = "PGK";
    CurrencyCodes["PHILIPPINE_PESO"] = "PHP";
    CurrencyCodes["PAKISTANI_RUPEE"] = "PKR";
    CurrencyCodes["POLISH_ZLOTY"] = "PLN";
    CurrencyCodes["PITCAIRN_ISLANDS_DOLLAR"] = "PND";
    CurrencyCodes["PARAGUAYAN_GUARANI"] = "PYG";
    CurrencyCodes["QATARI_RIYAL"] = "QAR";
    CurrencyCodes["ROMANIAN_LEU"] = "RON";
    CurrencyCodes["SERBIAN_DINAR"] = "RSD";
    CurrencyCodes["RUSSIAN_RUBLE"] = "RUB";
    CurrencyCodes["RWANDAN_FRANC"] = "RWF";
    CurrencyCodes["SAUDI_RIYAL"] = "SAR";
    CurrencyCodes["SOLOMON_ISLANDS_DOLLAR"] = "SBD";
    CurrencyCodes["SEYCHELLOIS_RUPEE"] = "SCR";
    CurrencyCodes["SUDANESE_POUND"] = "SDG";
    CurrencyCodes["SWEDISH_KRONA"] = "SEK";
    CurrencyCodes["SINGAPORE_DOLLAR"] = "SGD";
    CurrencyCodes["SAINT_HELENA_POUND"] = "SHP";
    CurrencyCodes["SIERRA_LEONEAN_LEONE"] = "SLL";
    CurrencyCodes["SOMALI_SHILLING"] = "SOS";
    CurrencyCodes["SURINAMESE_DOLLAR"] = "SRD";
    CurrencyCodes["SOUTH_SUDANESE_POUND"] = "SSP";
    CurrencyCodes["SAO_TOME_AND_PRINCIPE_DOBRA"] = "STN";
    CurrencyCodes["SALVADORAN_COLON"] = "SVC";
    CurrencyCodes["SYRIAN_POUND"] = "SYP";
    CurrencyCodes["SWAZI_LILANGENI"] = "SZL";
    CurrencyCodes["THAI_BAHT"] = "THB";
    CurrencyCodes["TAJIKISTANI_SOMONI"] = "TJS";
    CurrencyCodes["TURKMENISTAN_MANAT"] = "TMT";
    CurrencyCodes["TUNISIAN_DOLLAR"] = "TND";
    CurrencyCodes["TONGAN_PAANGA"] = "TOP";
    CurrencyCodes["TURKISH_LIRA"] = "TRY";
    CurrencyCodes["TRINIDAD_AND_TOBAGO_DOLLAR"] = "TTD";
    CurrencyCodes["TUVALUAN_DOLLAR"] = "TVD";
    CurrencyCodes["NEW_TAIWAN_DOLLAR"] = "TWD";
    CurrencyCodes["TANZANIAN_SHILLING"] = "TZS";
    CurrencyCodes["UKRAINIAN_HRYVNIA"] = "UAH";
    CurrencyCodes["UGANDAN_SHILLING"] = "UGX";
    CurrencyCodes["UNITED_STATES_DOLLAR"] = "USD";
    CurrencyCodes["URUGUAYAN_PESO"] = "UYU";
    CurrencyCodes["UZBEKISTANI_SOM"] = "UZS";
    CurrencyCodes["VENEZUELAN_BOLIVAR_DIGITAL"] = "VED";
    CurrencyCodes["VENEZUELAN_BOLIVAR_SOBERANO"] = "VES";
    CurrencyCodes["VIETNAMESE_DONG"] = "VND";
    CurrencyCodes["VANUATU_VATU"] = "VUV";
    CurrencyCodes["SAMOAN_TALA"] = "WST";
    CurrencyCodes["CENTRAL_AFRICAN_FRANC"] = "XAF";
    CurrencyCodes["EAST_CARIBBEAN_DOLLAR"] = "XCD";
    CurrencyCodes["WEST_AFRICAN_FRANC"] = "XOF";
    CurrencyCodes["CFP_FRANC"] = "XPF";
    CurrencyCodes["YEMENI_RIAL"] = "YER";
    CurrencyCodes["SOUTH_AFRICAN_RAND"] = "ZAR";
    CurrencyCodes["ZAMBIAN_KWACHA"] = "ZMW";
    CurrencyCodes["ZIMBABWEAN_DOLLAR"] = "ZWL";
})(CurrencyCodes = exports.CurrencyCodes || (exports.CurrencyCodes = {}));
exports.CURRENCIES = {
    [CurrencyCodes.UNITED_ARAB_EMIRATES_DIRHAM]: {
        countryCode: "AE",
        name: "United Arab Emirates Dirham",
        demonym: "UAE",
        majorSingle: "Dirham",
        majorPlural: "Dirhams",
        ISOnum: 784,
        symbol: "د.إ.",
        symbolNative: "د.إ.",
        minorSingle: "Fils",
        minorPlural: "Fils",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.AFGHAN_AFGHANI]: {
        countryCode: "AF",
        name: "Afghan Afghani",
        demonym: "Afghan",
        majorSingle: "Afghani",
        majorPlural: "Afghani",
        ISOnum: 971,
        symbol: "Af",
        symbolNative: "؋",
        minorSingle: "Pul",
        minorPlural: "Pul",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ALBANIAN_LEK]: {
        countryCode: "AL",
        name: "Albanian Lek",
        demonym: "Albanian",
        majorSingle: "Lek",
        majorPlural: "Lekë",
        ISOnum: 8,
        symbol: "L",
        symbolNative: "L",
        minorSingle: "Qindarka",
        minorPlural: "Qindarka",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ARMENIAN_DRAM]: {
        countryCode: "AM",
        name: "Armenian Dram",
        demonym: "Armenian",
        majorSingle: "Dram",
        majorPlural: "Dram",
        ISOnum: 51,
        symbol: "֏",
        symbolNative: "դր",
        minorSingle: "Luma",
        minorPlural: "Luma",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NETHERLANDS_ANTILLEAN_GUILDER]: {
        countryCode: "NL",
        name: "Netherlands Antillean Guilder",
        demonym: "Netherlands Antillean",
        majorSingle: "Guilder",
        majorPlural: "Guilders",
        ISOnum: 532,
        symbol: "ƒ",
        symbolNative: "ƒ",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ANGOLAN_KWANZA]: {
        countryCode: "AO",
        name: "Angolan Kwanza",
        demonym: "Angolan",
        majorSingle: "Kwanza",
        majorPlural: "Kwanza",
        ISOnum: 973,
        symbol: "Kz",
        symbolNative: "Kz",
        minorSingle: "Centimo",
        minorPlural: "Centimos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ARGENTINE_PESO]: {
        countryCode: "AR",
        name: "Argentine Peso",
        demonym: "Argentine",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 32,
        symbol: "AR$",
        symbolNative: "$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.AUSTRALIAN_DOLLAR]: {
        countryCode: "AU",
        name: "Australian Dollar",
        demonym: "Australian",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 36,
        symbol: "AU$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ARUBAN_FLORIN]: {
        countryCode: "AW",
        name: "Aruban Florin",
        demonym: "Aruban",
        majorSingle: "Florin",
        majorPlural: "Florin",
        ISOnum: 533,
        symbol: "ƒ",
        symbolNative: "ƒ",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.AZERBAIJANI_MANAT]: {
        countryCode: "AZ",
        name: "Azerbaijani Manat",
        demonym: "Azerbaijani",
        majorSingle: "Manat",
        majorPlural: "Manat",
        ISOnum: 944,
        symbol: "ман",
        symbolNative: "₼",
        minorSingle: "Qapik",
        minorPlural: "Qapik",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BOSNIA_AND_HERZEGOVINA_CONVERTIBLE_MARK]: {
        countryCode: "BA",
        name: "Bosnia and Herzegovina Convertible Mark",
        demonym: "Bosnia-Herzegovina",
        majorSingle: "Convertible Mark",
        majorPlural: "Marks",
        ISOnum: 977,
        symbol: "KM",
        symbolNative: "КМ",
        minorSingle: "Fening",
        minorPlural: "Fening",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BARBADIAN_DOLLAR]: {
        countryCode: "BB",
        name: "Barbadian Dollar",
        demonym: "Barbadian",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 52,
        symbol: "BBD$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BANGLADESHI_TAKA]: {
        countryCode: "BD",
        name: "Bangladeshi Taka",
        demonym: "Bangladeshi",
        majorSingle: "Taka",
        majorPlural: "Taka",
        ISOnum: 50,
        symbol: "৳",
        symbolNative: "৳",
        minorSingle: "Poisha",
        minorPlural: "Poisha",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BULGARIAN_LEV]: {
        countryCode: "BG",
        name: "Bulgarian Lev",
        demonym: "Bulgarian",
        majorSingle: "Lev",
        majorPlural: "Leva",
        ISOnum: 975,
        symbol: "лв.",
        symbolNative: "лв.",
        minorSingle: "Stotinka",
        minorPlural: "Stotinki",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BAHRAINI_DINAR]: {
        countryCode: "BH",
        name: "Bahraini Dinar",
        demonym: "Bahraini",
        majorSingle: "Dinar",
        majorPlural: "Dinars",
        ISOnum: 48,
        symbol: "BD",
        symbolNative: "د.ب.",
        minorSingle: "Fils",
        minorPlural: "Fils",
        ISOdigits: 3,
        decimals: 3,
        numToBasic: 1000,
    },
    [CurrencyCodes.BURUNDIAN_FRANC]: {
        countryCode: "BI",
        name: "Burundian Franc",
        demonym: "Burundian",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 108,
        symbol: "FBu",
        symbolNative: "FBu",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BERMUDIAN_DOLLAR]: {
        countryCode: "BM",
        name: "Bermudian Dollar",
        demonym: "Bermudian",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 60,
        symbol: "$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BRUNEI_DOLLAR]: {
        countryCode: "BN",
        name: "Brunei Dollar",
        demonym: "Brunei",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 96,
        symbol: "B$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BOLIVIAN_BOLIVIANO]: {
        countryCode: "BO",
        name: "Bolivian Boliviano",
        demonym: "Bolivian",
        majorSingle: "Boliviano",
        majorPlural: "Bolivianos",
        ISOnum: 68,
        symbol: "Bs.",
        symbolNative: "Bs.",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BRAZILIAN_REAL]: {
        countryCode: "BR",
        name: "Brazilian Real",
        demonym: "Brazilian",
        majorSingle: "Real",
        majorPlural: "Reais",
        ISOnum: 986,
        symbol: "R$",
        symbolNative: "R$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BAHAMIAN_DOLLAR]: {
        countryCode: "BS",
        name: "Bahamian Dollar",
        demonym: "Bahamian",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 44,
        symbol: "$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BHUTANESE_NGULTRUM]: {
        countryCode: "BT",
        name: "Bhutanese Ngultrum",
        demonym: "Bhutanese",
        majorSingle: "Ngultrum",
        majorPlural: "Ngultrums",
        ISOnum: 64,
        symbol: "Nu.",
        symbolNative: "Nu.",
        minorSingle: "Chetrum",
        minorPlural: "Chetrums",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BOTSWANA_PULA]: {
        countryCode: "BW",
        name: "Botswana Pula",
        demonym: "Botswana",
        majorSingle: "Pula",
        majorPlural: "Pula",
        ISOnum: 72,
        symbol: "P",
        symbolNative: "P",
        minorSingle: "Thebe",
        minorPlural: "Thebe",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BELARUSIAN_RUBLE]: {
        countryCode: "BY",
        name: "Belarusian Ruble",
        demonym: "Belarusian",
        majorSingle: "Ruble",
        majorPlural: "Rubles",
        ISOnum: 933,
        symbol: "Br",
        symbolNative: "руб.",
        minorSingle: "Kapiejka",
        minorPlural: "Kapiejka",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.BELIZE_DOLLAR]: {
        countryCode: "BZ",
        name: "Belize Dollar",
        demonym: "Belize",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 84,
        symbol: "BZ$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CANADIAN_DOLLAR]: {
        countryCode: "CA",
        name: "Canadian Dollar",
        demonym: "Canadian",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 124,
        symbol: "CA$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CONGOLESE_FRANC]: {
        countryCode: "CG",
        name: "Congolese Franc",
        demonym: "Congolese",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 976,
        symbol: "FC",
        symbolNative: "₣",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SWISS_FRANC]: {
        countryCode: "CH",
        name: "Swiss Franc",
        demonym: "Swiss",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 756,
        symbol: "Fr.",
        symbolNative: "₣",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.COOK_ISLANDS_DOLLAR]: {
        countryCode: "CK",
        name: "Cook Islands Dollar",
        demonym: "Cook Islands",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: null,
        symbol: "$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CHILEAN_PESO]: {
        countryCode: "CL",
        name: "Chilean Peso",
        demonym: "Chilean",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 152,
        symbol: "CL$",
        symbolNative: "$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 0,
        decimals: 0,
        numToBasic: 100,
    },
    [CurrencyCodes.CHINESE_YUAN]: {
        countryCode: "CN",
        name: "Chinese Yuan",
        demonym: "Chinese",
        majorSingle: "Yuan",
        majorPlural: "Yuan",
        ISOnum: 156,
        symbol: "CN¥",
        symbolNative: "¥元",
        minorSingle: "Fen",
        minorPlural: "Fen",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.COLOMBIAN_PESO]: {
        countryCode: "CO",
        name: "Colombian Peso",
        demonym: "Colombian",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 170,
        symbol: "CO$",
        symbolNative: "$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.COSTA_RICAN_COLON]: {
        countryCode: "CR",
        name: "Costa Rican Colon",
        demonym: "Costa Rican",
        majorSingle: "Colón",
        majorPlural: "Colones",
        ISOnum: 188,
        symbol: "₡",
        symbolNative: "₡",
        minorSingle: "Centimo",
        minorPlural: "Centimos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CUBAN_CONVERTIBLE_PESO]: {
        countryCode: "CU",
        name: "Cuban convertible Peso",
        demonym: "Cuban Convertible",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 931,
        symbol: "CUC$",
        symbolNative: "$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CUBAN_PESO]: {
        countryCode: "CU",
        name: "Cuban Peso",
        demonym: "Cuban",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 192,
        symbol: "$MN",
        symbolNative: "₱",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CABO_VERDEAN_ESCUDO]: {
        countryCode: "CV",
        name: "Cabo Verdean Escudo",
        demonym: "Cabo Verdean",
        majorSingle: "Escudo",
        majorPlural: "Escudo",
        ISOnum: 132,
        symbol: "CV$",
        symbolNative: "$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CZECH_KORUNA]: {
        countryCode: "CZ",
        name: "Czech Koruna",
        demonym: "Czech",
        majorSingle: "Koruna",
        majorPlural: "Koruny",
        ISOnum: 203,
        symbol: "Kč",
        symbolNative: "Kč",
        minorSingle: "Haléř",
        minorPlural: "Haléř",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.DJIBOUTIAN_FRANC]: {
        countryCode: "DJ",
        name: "Djiboutian Franc",
        demonym: "Djiboutian",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 262,
        symbol: "Fdj",
        symbolNative: "ف.ج.",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.DANISH_KRONA]: {
        countryCode: "DK",
        name: "Danish Krone",
        demonym: "Danish",
        majorSingle: "Krone",
        majorPlural: "Kroner",
        ISOnum: 208,
        symbol: "kr.",
        symbolNative: "kr.",
        minorSingle: "Øre",
        minorPlural: "Øre",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.DOMINICAN_PESO]: {
        countryCode: "DO",
        name: "Dominican Peso",
        demonym: "Dominican",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 214,
        symbol: "RD$",
        symbolNative: "$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ALGERIAN_DINAR]: {
        countryCode: "DZ",
        name: "Algerian Dinar",
        demonym: "Algerian",
        majorSingle: "Dinar",
        majorPlural: "Dinars",
        ISOnum: 12,
        symbol: "DA",
        symbolNative: "د.ج.",
        minorSingle: "Santeem",
        minorPlural: "Santeems",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.EGYPTIAN_POUND]: {
        countryCode: "EG",
        name: "Egyptian Pound",
        demonym: "Egyptian",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 818,
        symbol: "E£",
        symbolNative: "ج.م.",
        minorSingle: "Qirsh",
        minorPlural: "Qirsh",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ERITREAN_NAKFA]: {
        countryCode: "ER",
        name: "Eritrean Nakfa",
        demonym: "Eritrean",
        majorSingle: "Nakfa",
        majorPlural: "Nakfa",
        ISOnum: 232,
        symbol: "Nkf",
        symbolNative: "ناكفا",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ETHIOPIAN_BIRR]: {
        countryCode: "ET",
        name: "Ethiopian Birr",
        demonym: "Ethiopian",
        majorSingle: "Birr",
        majorPlural: "Birr",
        ISOnum: 230,
        symbol: "Br",
        symbolNative: "ብር",
        minorSingle: "Santim",
        minorPlural: "Santim",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.EURO]: {
        countryCode: "EU",
        name: "Euro",
        demonym: "",
        majorSingle: "Euro",
        majorPlural: "Euros",
        ISOnum: 978,
        symbol: "€",
        symbolNative: "€",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.FIJIAN_DOLLAR]: {
        countryCode: "FJ",
        name: "Fijian Dollar",
        demonym: "Fijian",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 242,
        symbol: "FJ$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.FALKLAND_ISLANDS_POUND]: {
        countryCode: "FK",
        name: "Falkland Islands Pound",
        demonym: "Falkland Islands",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 238,
        symbol: "FK£",
        symbolNative: "£",
        minorSingle: "Penny",
        minorPlural: "Pence",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.FAROESE_KRONA]: {
        countryCode: "FI",
        name: "Faroese Króna",
        demonym: "Faroese",
        majorSingle: "Króna",
        majorPlural: "Krónas",
        ISOnum: null,
        symbol: "kr",
        symbolNative: "kr",
        minorSingle: "Oyra",
        minorPlural: "Oyra",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.POUND_STERLING]: {
        countryCode: "GB",
        name: "Pound Sterling",
        demonym: "Pound Sterling",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 826,
        symbol: "£",
        symbolNative: "£",
        minorSingle: "Penny",
        minorPlural: "Pence",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.GEORGIAN_LARI]: {
        countryCode: "GE",
        name: "Georgian Lari",
        demonym: "Georgian",
        majorSingle: "Lari",
        majorPlural: "Lari",
        ISOnum: 981,
        symbol: "₾",
        symbolNative: "₾",
        minorSingle: "Tetri",
        minorPlural: "Tetri",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.GUERNSEY_POUND]: {
        countryCode: "GG",
        name: "Guernsey Pound",
        demonym: "Guernsey",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: null,
        symbol: "£",
        symbolNative: "£",
        minorSingle: "Penny",
        minorPlural: "Pence",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.GHANIAN_CEDI]: {
        countryCode: "GH",
        name: "Ghanaian Cedi",
        demonym: "Ghanaian",
        majorSingle: "Cedi",
        majorPlural: "Cedis",
        ISOnum: 936,
        symbol: "GH₵",
        symbolNative: "₵",
        minorSingle: "Pesewa",
        minorPlural: "Pesewas",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.GIBRALTAR_POUND]: {
        countryCode: "GI",
        name: "Gibraltar Pound",
        demonym: "Gibraltar",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 292,
        symbol: "£",
        symbolNative: "£",
        minorSingle: "Penny",
        minorPlural: "Pence",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.GAMBIAN_DALASI]: {
        countryCode: "GM",
        name: "Gambian Dalasi",
        demonym: "Gambian",
        majorSingle: "Dalasi",
        majorPlural: "Dalasis",
        ISOnum: 270,
        symbol: "D",
        symbolNative: "D",
        minorSingle: "Butut",
        minorPlural: "Bututs",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.GUINEAN_FRANC]: {
        countryCode: "GN",
        name: "Guinean Franc",
        demonym: "Guinean",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 324,
        symbol: "FG",
        symbolNative: "FG",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.GUATEMALAN_QUETZAL]: {
        countryCode: "GT",
        name: "Guatemalan Quetzal",
        demonym: "Guatemalan",
        majorSingle: "Quetzal",
        majorPlural: "Quetzales",
        ISOnum: 320,
        symbol: "Q",
        symbolNative: "$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.GUYANESE_DOLLAR]: {
        countryCode: "GY",
        name: "Guyanese Dollar",
        demonym: "Guyanese",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 328,
        symbol: "G$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.HONG_KONG_DOLLAR]: {
        countryCode: "HK",
        name: "Hong Kong Dollar",
        demonym: "Hong Kong",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 344,
        symbol: "HK$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.HONDURAN_LEMPIRA]: {
        countryCode: "HN",
        name: "Honduran Lempira",
        demonym: "Honduran",
        majorSingle: "Lempira",
        majorPlural: "Lempiras",
        ISOnum: 340,
        symbol: "L",
        symbolNative: "L",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CROATIAN_KUNA]: {
        countryCode: "HR",
        name: "Croatian Kuna",
        demonym: "Croatian",
        majorSingle: "Kuna",
        majorPlural: "Kuna",
        ISOnum: 191,
        symbol: "kn",
        symbolNative: "kn",
        minorSingle: "Lipa",
        minorPlural: "Lipa",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.HAITIAN_GOURDE]: {
        countryCode: "HT",
        name: "Haitian Gourde",
        demonym: "Haitian",
        majorSingle: "Gourde",
        majorPlural: "Gourdes",
        ISOnum: 332,
        symbol: "G",
        symbolNative: "G",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.HUNGARIAN_FORINT]: {
        countryCode: "HU",
        name: "Hungarian Forint",
        demonym: "Hungarian",
        majorSingle: "Forint",
        majorPlural: "Forint",
        ISOnum: 348,
        symbol: "Ft",
        symbolNative: "Ft",
        minorSingle: "fillér",
        minorPlural: "fillér",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.INDONESIAN_RUPIAH]: {
        countryCode: "ID",
        name: "Indonesian Rupiah",
        demonym: "Indonesian",
        majorSingle: "Rupiah",
        majorPlural: "Rupiah",
        ISOnum: 360,
        symbol: "Rp",
        symbolNative: "Rp",
        minorSingle: "Sen",
        minorPlural: "Sen",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ISRAELI_NEW_SHEKEL]: {
        countryCode: "IL",
        name: "Israeli new Shekel",
        demonym: "Israeli",
        majorSingle: "Shekel",
        majorPlural: "Shekels",
        ISOnum: 376,
        symbol: "₪",
        symbolNative: "₪",
        minorSingle: "Agora",
        minorPlural: "Agoras",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MANX_POUND]: {
        countryCode: "IM",
        name: "Manx Pound",
        demonym: "Manx",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: null,
        symbol: "£",
        symbolNative: "£",
        minorSingle: "Penny",
        minorPlural: "Pence",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.INDIAN_RUPEE]: {
        countryCode: "IN",
        name: "Indian Rupee",
        demonym: "Indian",
        majorSingle: "Rupee",
        majorPlural: "Rupees",
        ISOnum: 356,
        symbol: "Rs.",
        symbolNative: "₹",
        minorSingle: "Paisa",
        minorPlural: "Paise",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.IRAQI_DINAR]: {
        countryCode: "IQ",
        name: "Iraqi Dinar",
        demonym: "Iraqi",
        majorSingle: "Dinar",
        majorPlural: "Dinars",
        ISOnum: 368,
        symbol: "د.ع.",
        symbolNative: "د.ع.",
        minorSingle: "Fils",
        minorPlural: "Fils",
        ISOdigits: 3,
        decimals: 3,
        numToBasic: 1000,
    },
    [CurrencyCodes.IRANIAN_RIAL]: {
        countryCode: "IR",
        name: "Iranian Rial",
        demonym: "Iranian",
        majorSingle: "Rial",
        majorPlural: "Rials",
        ISOnum: 364,
        symbol: "﷼",
        symbolNative: "﷼",
        minorSingle: "Dinar",
        minorPlural: "Dinars",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ICELANDIC_KRONA]: {
        countryCode: "IS",
        name: "Icelandic Krona",
        demonym: "Icelandic",
        majorSingle: "Krona",
        majorPlural: "Krónur",
        ISOnum: 352,
        symbol: "kr",
        symbolNative: "kr",
        minorSingle: "Aurar",
        minorPlural: "Aurar",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.JERSEY_POUND]: {
        countryCode: "JE",
        name: "Jersey Pound",
        demonym: "Jersey",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: null,
        symbol: "£",
        symbolNative: "£",
        minorSingle: "Penny",
        minorPlural: "Pence",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.JAMAICAN_DOLLAR]: {
        countryCode: "JM",
        name: "Jamaican Dollar",
        demonym: "Jamaican",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 388,
        symbol: "J$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.JORDANIAN_DOLLAR]: {
        countryCode: "JO",
        name: "Jordanian Dinar",
        demonym: "Jordanian",
        majorSingle: "Dinar",
        majorPlural: "Dinars",
        ISOnum: 400,
        symbol: "JD",
        symbolNative: "د.أ.",
        minorSingle: "Fils",
        minorPlural: "Fils",
        ISOdigits: 3,
        decimals: 3,
        numToBasic: 1000,
    },
    [CurrencyCodes.JAPANESE_YEN]: {
        countryCode: "JP",
        name: "Japanese Yen",
        demonym: "Japanese",
        majorSingle: "Yen",
        majorPlural: "Yen",
        ISOnum: 392,
        symbol: "¥",
        symbolNative: "¥",
        minorSingle: "Sen",
        minorPlural: "Sen",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.KENYAN_SHILLING]: {
        countryCode: "KE",
        name: "Kenyan Shilling",
        demonym: "Kenyan",
        majorSingle: "Shilling",
        majorPlural: "Shillings",
        ISOnum: 404,
        symbol: "KSh",
        symbolNative: "KSh",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.KYRGYZSTANI_SOM]: {
        countryCode: "KG",
        name: "Kyrgyzstani Som",
        demonym: "Kyrgyzstani",
        majorSingle: "Som",
        majorPlural: "Som",
        ISOnum: 417,
        symbol: "с",
        symbolNative: "с",
        minorSingle: "Tyiyn",
        minorPlural: "Tyiyn",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CAMBODIAN_RIEL]: {
        countryCode: "KH",
        name: "Cambodian Riel",
        demonym: "Cambodian",
        majorSingle: "Riel",
        majorPlural: "Riels",
        ISOnum: 116,
        symbol: "៛",
        symbolNative: "៛",
        minorSingle: "Sen",
        minorPlural: "Sen",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.KIRIBATI_DOLLAR]: {
        countryCode: "KI",
        name: "Kiribati Dollar",
        demonym: "Kiribati",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: null,
        symbol: "$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.COMORIAN_FRANC]: {
        countryCode: "KM",
        name: "Comorian Franc",
        demonym: "Comorian",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 174,
        symbol: "CF",
        symbolNative: "CF",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NORTH_KOREAN_WON]: {
        countryCode: "KP",
        name: "North Korean Won",
        demonym: "North Korean",
        majorSingle: "Won",
        majorPlural: "Won",
        ISOnum: 408,
        symbol: "₩",
        symbolNative: "₩",
        minorSingle: "Chon",
        minorPlural: "Chon",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SOUTH_KOREAN_WON]: {
        countryCode: "KR",
        name: "South Korean Won",
        demonym: "South Korean",
        majorSingle: "Won",
        majorPlural: "Won",
        ISOnum: 410,
        symbol: "₩",
        symbolNative: "₩",
        minorSingle: "Jeon",
        minorPlural: "Jeon",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.KUWAITI_DINAR]: {
        countryCode: "KW",
        name: "Kuwaiti Dinar",
        demonym: "Kuwaiti",
        majorSingle: "Dinar",
        majorPlural: "Dinars",
        ISOnum: 414,
        symbol: "KD",
        symbolNative: "د.ك.",
        minorSingle: "Fils",
        minorPlural: "Fils",
        ISOdigits: 3,
        decimals: 3,
        numToBasic: 1000,
    },
    [CurrencyCodes.CAYMAN_ISLANDS_DOLLAR]: {
        countryCode: "KY",
        name: "Cayman Islands Dollar",
        demonym: "Cayman Islands",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 136,
        symbol: "CI$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.KAZAKHSTANI_TENGE]: {
        countryCode: "KZ",
        name: "Kazakhstani Tenge",
        demonym: "Kazakhstani",
        majorSingle: "Tenge",
        majorPlural: "Tenge",
        ISOnum: 398,
        symbol: "₸",
        symbolNative: "₸",
        minorSingle: "Tıyn",
        minorPlural: "Tıyn",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.LAO_KIP]: {
        countryCode: "LA",
        name: "Lao Kip",
        demonym: "Lao",
        majorSingle: "Kip",
        majorPlural: "Kip",
        ISOnum: 418,
        symbol: "₭N",
        symbolNative: "₭",
        minorSingle: "Att",
        minorPlural: "Att",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.LEBANESE_POUND]: {
        countryCode: "LB",
        name: "Lebanese Pound",
        demonym: "Lebanese",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 422,
        symbol: "LL.",
        symbolNative: "ل.ل.",
        minorSingle: "Qirsh",
        minorPlural: "Qirsh",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SRI_LANKAN_RUPEE]: {
        countryCode: "LK",
        name: "Sri Lankan Rupee",
        demonym: "Sri Lankan",
        majorSingle: "Rupee",
        majorPlural: "Rupees",
        ISOnum: 144,
        symbol: "Rs.",
        symbolNative: "රු or ரூ",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.LIBERIAN_DOLLAR]: {
        countryCode: "LR",
        name: "Liberian Dollar",
        demonym: "Liberian",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 430,
        symbol: "L$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.LESOTHO_LOTI]: {
        countryCode: "LS",
        name: "Lesotho Loti",
        demonym: "Lesotho",
        majorSingle: "Loti",
        majorPlural: "maLoti",
        ISOnum: 426,
        symbol: "L",
        symbolNative: "L",
        minorSingle: "Sente",
        minorPlural: "Lisente",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.LIBYAN_DINAR]: {
        countryCode: "LY",
        name: "Libyan Dinar",
        demonym: "Libyan",
        majorSingle: "Dinar",
        majorPlural: "Dinars",
        ISOnum: 434,
        symbol: "LD",
        symbolNative: "ل.د.",
        minorSingle: "Dirham",
        minorPlural: "Dirhams",
        ISOdigits: 3,
        decimals: 3,
        numToBasic: 1000,
    },
    [CurrencyCodes.MOROCCAN_DIRHAM]: {
        countryCode: "MA",
        name: "Moroccan Dirham",
        demonym: "Moroccan",
        majorSingle: "Dirham",
        majorPlural: "Dirhams",
        ISOnum: 504,
        symbol: "DH",
        symbolNative: "د.م.",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MOLDOVAN_LEU]: {
        countryCode: "MD",
        name: "Moldovan Leu",
        demonym: "Moldovan",
        majorSingle: "Leu",
        majorPlural: "Lei",
        ISOnum: 498,
        symbol: "L",
        symbolNative: "L",
        minorSingle: "Ban",
        minorPlural: "Bani",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MALAGASY_ARIARY]: {
        countryCode: "MG",
        name: "Malagasy Ariary",
        demonym: "Malagasy",
        majorSingle: "Ariary",
        majorPlural: "Ariary",
        ISOnum: 969,
        symbol: "Ar",
        symbolNative: "Ar",
        minorSingle: "Iraimbilanja",
        minorPlural: "Iraimbilanja",
        ISOdigits: 2,
        decimals: 0,
        numToBasic: 5,
    },
    [CurrencyCodes.MACEDONIAN_DENAR]: {
        countryCode: "MK",
        name: "Macedonian Denar",
        demonym: "Macedonian",
        majorSingle: "Denar",
        majorPlural: "Denars",
        ISOnum: 807,
        symbol: "den",
        symbolNative: "ден",
        minorSingle: "Deni",
        minorPlural: "Deni",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MYANMAR_KYAT]: {
        countryCode: "MM",
        name: "Myanmar Kyat",
        demonym: "Myanmar",
        majorSingle: "Kyat",
        majorPlural: "Kyat",
        ISOnum: 104,
        symbol: "Ks",
        symbolNative: "Ks",
        minorSingle: "Pya",
        minorPlural: "Pya",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MONGOLIAN_TOGROG]: {
        countryCode: "MN",
        name: "Mongolian Tögrög",
        demonym: "Mongolian",
        majorSingle: "Tögrög",
        majorPlural: "Tögrög",
        ISOnum: 496,
        symbol: "₮",
        symbolNative: "₮",
        minorSingle: "möngö",
        minorPlural: "möngö",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MACANESE_PATACA]: {
        countryCode: "MO",
        name: "Macanese Pataca",
        demonym: "Macanese",
        majorSingle: "Pataca",
        majorPlural: "Patacas",
        ISOnum: 446,
        symbol: "MOP$",
        symbolNative: "MOP$",
        minorSingle: "Avo",
        minorPlural: "Avos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MAURITANIAN_OUGUIYA]: {
        countryCode: "MR",
        name: "Mauritanian Ouguiya",
        demonym: "Mauritanian",
        majorSingle: "Ouguiya",
        majorPlural: "Ouguiya",
        ISOnum: 929,
        symbol: "UM",
        symbolNative: "أ.م.",
        minorSingle: "Khoums",
        minorPlural: "Khoums",
        ISOdigits: 2,
        decimals: 0,
        numToBasic: 5,
    },
    [CurrencyCodes.MAURITANIAN_RUPEE]: {
        countryCode: "MU",
        name: "Mauritian Rupee",
        demonym: "Mauritian",
        majorSingle: "Rupee",
        majorPlural: "Rupees",
        ISOnum: 480,
        symbol: "Rs.",
        symbolNative: "रु ",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MALDIVIAN_RUFIYAA]: {
        countryCode: "MV",
        name: "Maldivian Rufiyaa",
        demonym: "Maldivian",
        majorSingle: "Rufiyaa",
        majorPlural: "Rufiyaa",
        ISOnum: 462,
        symbol: "MRf",
        symbolNative: ".ރ",
        minorSingle: "laari",
        minorPlural: "laari",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MALAWIAN_KWACHA]: {
        countryCode: "MW",
        name: "Malawian Kwacha",
        demonym: "Malawian",
        majorSingle: "Kwacha",
        majorPlural: "Kwacha",
        ISOnum: 454,
        symbol: "MK",
        symbolNative: "MK",
        minorSingle: "Tambala",
        minorPlural: "Tambala",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MEXICAN_PESO]: {
        countryCode: "MX",
        name: "Mexican Peso",
        demonym: "Mexican",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 484,
        symbol: "MX$",
        symbolNative: "$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MALAYSIAN_RINGGIT]: {
        countryCode: "MY",
        name: "Malaysian Ringgit",
        demonym: "Malaysian",
        majorSingle: "Ringgit",
        majorPlural: "Ringgit",
        ISOnum: 458,
        symbol: "RM",
        symbolNative: "RM",
        minorSingle: "Sen",
        minorPlural: "Sen",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.MOZAMBICAN_METICAL]: {
        countryCode: "MZ",
        name: "Mozambican Metical",
        demonym: "Mozambican",
        majorSingle: "Metical",
        majorPlural: "Meticais",
        ISOnum: 943,
        symbol: "MTn",
        symbolNative: "MT",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NAMIBIAN_DOLLAR]: {
        countryCode: "NA",
        name: "Namibian Dollar",
        demonym: "Namibian",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 516,
        symbol: "N$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NIGERIAN_NAIRA]: {
        countryCode: "NG",
        name: "Nigerian Naira",
        demonym: "Nigerian",
        majorSingle: "Naira",
        majorPlural: "Naira",
        ISOnum: 566,
        symbol: "₦",
        symbolNative: "₦",
        minorSingle: "Kobo",
        minorPlural: "Kobo",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NICARAGUAN_CORDOBA]: {
        countryCode: "NI",
        name: "Nicaraguan Córdoba",
        demonym: "Nicaraguan",
        majorSingle: "Córdoba Oro",
        majorPlural: "Córdoba Oro",
        ISOnum: 558,
        symbol: "C$",
        symbolNative: "C$",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NORWEGIAN_KRONA]: {
        countryCode: "NO",
        name: "Norwegian Krone",
        demonym: "Norwegian",
        majorSingle: "Krone",
        majorPlural: "Kroner",
        ISOnum: 578,
        symbol: "kr",
        symbolNative: "kr",
        minorSingle: "øre",
        minorPlural: "øre",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NEPALESE_RUPEE]: {
        countryCode: "NP",
        name: "Nepalese Rupee",
        demonym: "Nepalese",
        majorSingle: "Rupee",
        majorPlural: "Rupees",
        ISOnum: 524,
        symbol: "Rs.",
        symbolNative: "रू",
        minorSingle: "Paisa",
        minorPlural: "Paise",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NEW_ZEALAND_DOLLAR]: {
        countryCode: "NZ",
        name: "New Zealand Dollar",
        demonym: "New Zealand",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 554,
        symbol: "NZ$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.OMANI_RIAL]: {
        countryCode: "OM",
        name: "Omani Rial",
        demonym: "Omani",
        majorSingle: "Rial",
        majorPlural: "Rials",
        ISOnum: 512,
        symbol: "OR",
        symbolNative: "ر.ع.",
        minorSingle: "Baisa",
        minorPlural: "Baisa",
        ISOdigits: 3,
        decimals: 3,
        numToBasic: 1000,
    },
    [CurrencyCodes.PANAMANIAN_BALBOA]: {
        countryCode: "PA",
        name: "Panamanian Balboa",
        demonym: "Panamanian",
        majorSingle: "Balboa",
        majorPlural: "Balboa",
        ISOnum: 590,
        symbol: "B/.",
        symbolNative: "B/.",
        minorSingle: "Centésimo",
        minorPlural: "Centésimos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.PERUVIAN_SOL]: {
        countryCode: "PE",
        name: "Peruvian Sol",
        demonym: "Peruvian",
        majorSingle: "Sol",
        majorPlural: "Soles",
        ISOnum: 604,
        symbol: "S/.",
        symbolNative: "S/.",
        minorSingle: "Céntimo",
        minorPlural: "Céntimos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.PAPUA_NEW_GUINEAN_KINA]: {
        countryCode: "PG",
        name: "Papua New Guinean Kina",
        demonym: "Papua New Guinean",
        majorSingle: "Kina",
        majorPlural: "Kina",
        ISOnum: 598,
        symbol: "K",
        symbolNative: "K",
        minorSingle: "Toea",
        minorPlural: "Toea",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.PHILIPPINE_PESO]: {
        countryCode: "PH",
        name: "Philippine Peso",
        demonym: "Philippine",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 608,
        symbol: "₱",
        symbolNative: "₱",
        minorSingle: "Sentimo",
        minorPlural: "Sentimo",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.PAKISTANI_RUPEE]: {
        countryCode: "PK",
        name: "Pakistani Rupee",
        demonym: "Pakistani",
        majorSingle: "Rupee",
        majorPlural: "Rupees",
        ISOnum: 586,
        symbol: "Rs.",
        symbolNative: "Rs",
        minorSingle: "Paisa",
        minorPlural: "Paise",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.POLISH_ZLOTY]: {
        countryCode: "PL",
        name: "Polish Zloty",
        demonym: "Polish",
        majorSingle: "Zloty",
        majorPlural: "Zlotys",
        ISOnum: 985,
        symbol: "zł",
        symbolNative: "zł",
        minorSingle: "Grosz",
        minorPlural: "Groszy",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.PITCAIRN_ISLANDS_DOLLAR]: {
        countryCode: "PN",
        name: "Pitcairn Islands Dollar",
        demonym: "Pitcairn Islands",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: null,
        symbol: "$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.PARAGUAYAN_GUARANI]: {
        countryCode: "PY",
        name: "Paraguayan Guaraní",
        demonym: "Paraguayan",
        majorSingle: "Guaraní",
        majorPlural: "Guaraníes",
        ISOnum: 600,
        symbol: "₲",
        symbolNative: "₲",
        minorSingle: "Centimo",
        minorPlural: "Centimos",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.QATARI_RIYAL]: {
        countryCode: "QA",
        name: "Qatari Riyal",
        demonym: "Qatari",
        majorSingle: "Riyal",
        majorPlural: "Riyals",
        ISOnum: 634,
        symbol: "QR",
        symbolNative: "ر.ق.",
        minorSingle: "Dirham",
        minorPlural: "Dirhams",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ROMANIAN_LEU]: {
        countryCode: "RO",
        name: "Romanian Leu",
        demonym: "Romanian",
        majorSingle: "Leu",
        majorPlural: "Lei",
        ISOnum: 946,
        symbol: "L",
        symbolNative: "L",
        minorSingle: "Ban",
        minorPlural: "Bani",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SERBIAN_DINAR]: {
        countryCode: "RS",
        name: "Serbian Dinar",
        demonym: "Serbian",
        majorSingle: "Dinar",
        majorPlural: "Dinars",
        ISOnum: 941,
        symbol: "din",
        symbolNative: "дин",
        minorSingle: "Para",
        minorPlural: "Para",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.RUSSIAN_RUBLE]: {
        countryCode: "RU",
        name: "Russian Ruble",
        demonym: "Russian",
        majorSingle: "Ruble",
        majorPlural: "Rubles",
        ISOnum: 643,
        symbol: "₽",
        symbolNative: "₽",
        minorSingle: "Kopek",
        minorPlural: "Kopeks",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.RWANDAN_FRANC]: {
        countryCode: "RW",
        name: "Rwandan Franc",
        demonym: "Rwandan",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 646,
        symbol: "FRw",
        symbolNative: "R₣",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SAUDI_RIYAL]: {
        countryCode: "SA",
        name: "Saudi Riyal",
        demonym: "Saudi",
        majorSingle: "Riyal",
        majorPlural: "Riyals",
        ISOnum: 682,
        symbol: "SR",
        symbolNative: "ر.س.",
        minorSingle: "Halalah",
        minorPlural: "Halalahs",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SOLOMON_ISLANDS_DOLLAR]: {
        countryCode: "SB",
        name: "Solomon Islands Dollar",
        demonym: "Solomon Islands",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 90,
        symbol: "SI$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SEYCHELLOIS_RUPEE]: {
        countryCode: "SC",
        name: "Seychellois Rupee",
        demonym: "Seychellois",
        majorSingle: "Rupee",
        majorPlural: "Rupees",
        ISOnum: 690,
        symbol: "Rs.",
        symbolNative: "Rs",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SUDANESE_POUND]: {
        countryCode: "SD",
        name: "Sudanese Pound",
        demonym: "Sudanese",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 938,
        symbol: "£SD",
        symbolNative: "ج.س.",
        minorSingle: "Qirsh",
        minorPlural: "Qirsh",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SWEDISH_KRONA]: {
        countryCode: "SE",
        name: "Swedish Krona",
        demonym: "Swedish",
        majorSingle: "Krona",
        majorPlural: "Kronor",
        ISOnum: 752,
        symbol: "kr",
        symbolNative: "kr",
        minorSingle: "Öre",
        minorPlural: "Öre",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SINGAPORE_DOLLAR]: {
        countryCode: "SG",
        name: "Singapore Dollar",
        demonym: "Singapore",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 702,
        symbol: "S$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SAINT_HELENA_POUND]: {
        countryCode: "SH",
        name: "Saint Helena Pound",
        demonym: "Saint Helena",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 654,
        symbol: "£",
        symbolNative: "£",
        minorSingle: "Penny",
        minorPlural: "Pence",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SIERRA_LEONEAN_LEONE]: {
        countryCode: "SL",
        name: "Sierra Leonean Leone",
        demonym: "Sierra Leonean",
        majorSingle: "Leone",
        majorPlural: "Leones",
        ISOnum: 694,
        symbol: "Le",
        symbolNative: "Le",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SOMALI_SHILLING]: {
        countryCode: "SO",
        name: "Somali Shilling",
        demonym: "Somali",
        majorSingle: "Shilling",
        majorPlural: "Shillings",
        ISOnum: 706,
        symbol: "Sh.So.",
        symbolNative: "Ssh",
        minorSingle: "Senti",
        minorPlural: "Senti",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SURINAMESE_DOLLAR]: {
        countryCode: "SR",
        name: "Surinamese Dollar",
        demonym: "Surinamese",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 968,
        symbol: "Sr$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SOUTH_SUDANESE_POUND]: {
        countryCode: "SD",
        name: "South Sudanese Pound",
        demonym: "South Sudanese",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 728,
        symbol: "SS£",
        symbolNative: "SS£",
        minorSingle: "Qirsh",
        minorPlural: "Qirsh",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SAO_TOME_AND_PRINCIPE_DOBRA]: {
        countryCode: "ST",
        name: "Sao Tome and Príncipe Dobra",
        demonym: "Sao Tome",
        majorSingle: "Dobra",
        majorPlural: "Dobras",
        ISOnum: 930,
        symbol: "Db",
        symbolNative: "Db",
        minorSingle: "Centimo",
        minorPlural: "Centimos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SALVADORAN_COLON]: {
        countryCode: "SV",
        name: "Salvadoran Colón",
        demonym: "Salvadoran",
        majorSingle: "Colón",
        majorPlural: "Colones",
        ISOnum: 222,
        symbol: "₡",
        symbolNative: "₡",
        minorSingle: "Centavo",
        minorPlural: "Centavos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SYRIAN_POUND]: {
        countryCode: "SY",
        name: "Syrian Pound",
        demonym: "Syrian",
        majorSingle: "Pound",
        majorPlural: "Pounds",
        ISOnum: 760,
        symbol: "LS",
        symbolNative: "ل.س.",
        minorSingle: "Qirsh",
        minorPlural: "Qirsh",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SWAZI_LILANGENI]: {
        countryCode: "SZ",
        name: "Swazi Lilangeni",
        demonym: "Swazi",
        majorSingle: "Lilangeni",
        majorPlural: "Emalangeni",
        ISOnum: 748,
        symbol: "L",
        symbolNative: "L",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.THAI_BAHT]: {
        countryCode: "TH",
        name: "Thai Baht",
        demonym: "Thai",
        majorSingle: "Baht",
        majorPlural: "Baht",
        ISOnum: 764,
        symbol: "฿",
        symbolNative: "฿",
        minorSingle: "Satang",
        minorPlural: "Satang",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.TAJIKISTANI_SOMONI]: {
        countryCode: "TJ",
        name: "Tajikistani Somoni",
        demonym: "Tajikistani",
        majorSingle: "Somoni",
        majorPlural: "Somoni",
        ISOnum: 972,
        symbol: "SM",
        symbolNative: "SM",
        minorSingle: "Diram",
        minorPlural: "Diram",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.TURKMENISTAN_MANAT]: {
        countryCode: "TM",
        name: "Turkmenistan Manat",
        demonym: "Turkmenistan",
        majorSingle: "Manat",
        majorPlural: "Manat",
        ISOnum: 934,
        symbol: "m.",
        symbolNative: "T",
        minorSingle: "Tenge",
        minorPlural: "Tenge",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.TUNISIAN_DOLLAR]: {
        countryCode: "TN",
        name: "Tunisian Dinar",
        demonym: "Tunisian",
        majorSingle: "Dinar",
        majorPlural: "Dinars",
        ISOnum: 788,
        symbol: "DT",
        symbolNative: "د.ت.",
        minorSingle: "Millime",
        minorPlural: "Millime",
        ISOdigits: 3,
        decimals: 3,
        numToBasic: 1000,
    },
    [CurrencyCodes.TONGAN_PAANGA]: {
        countryCode: "TO",
        name: "Tongan Paʻanga",
        demonym: "Tongan",
        majorSingle: "Pa'anga",
        majorPlural: "Pa'anga",
        ISOnum: 776,
        symbol: "T$",
        symbolNative: "PT",
        minorSingle: "Seniti",
        minorPlural: "Seniti",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.TURKISH_LIRA]: {
        countryCode: "TR",
        name: "Turkish Lira",
        demonym: "Turkish",
        majorSingle: "Lira",
        majorPlural: "Lira",
        ISOnum: 949,
        symbol: "TL",
        symbolNative: "₺",
        minorSingle: "Kuruş",
        minorPlural: "Kuruş",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.TRINIDAD_AND_TOBAGO_DOLLAR]: {
        countryCode: "TT",
        name: "Trinidad and Tobago Dollar",
        demonym: "Trinidad and Tobago",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 780,
        symbol: "TT$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.TUVALUAN_DOLLAR]: {
        countryCode: "TV",
        name: "Tuvaluan Dollar",
        demonym: "Tuvaluan",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: null,
        symbol: "$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.NEW_TAIWAN_DOLLAR]: {
        countryCode: "TW",
        name: "New Taiwan Dollar",
        demonym: "New Taiwan",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 901,
        symbol: "NT$",
        symbolNative: "圓",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.TANZANIAN_SHILLING]: {
        countryCode: "TZ",
        name: "Tanzanian Shilling",
        demonym: "Tanzanian",
        majorSingle: "Shilling",
        majorPlural: "Shillings",
        ISOnum: 834,
        symbol: "TSh",
        symbolNative: "TSh",
        minorSingle: "Senti",
        minorPlural: "Senti",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.UKRAINIAN_HRYVNIA]: {
        countryCode: "UA",
        name: "Ukrainian Hryvnia",
        demonym: "Ukrainian",
        majorSingle: "Hryvnia",
        majorPlural: "Hryvnias",
        ISOnum: 980,
        symbol: "₴",
        symbolNative: "грн",
        minorSingle: "Kopiyka",
        minorPlural: "kopiyky",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.UGANDAN_SHILLING]: {
        countryCode: "UG",
        name: "Ugandan Shilling",
        demonym: "Ugandan",
        majorSingle: "Shilling",
        majorPlural: "Shillings",
        ISOnum: 800,
        symbol: "USh",
        symbolNative: "Sh",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.UNITED_STATES_DOLLAR]: {
        countryCode: "US",
        name: "United States Dollar",
        demonym: "US",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 840,
        symbol: "$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.URUGUAYAN_PESO]: {
        countryCode: "UY",
        name: "Uruguayan Peso",
        demonym: "Uruguayan",
        majorSingle: "Peso",
        majorPlural: "Pesos",
        ISOnum: 858,
        symbol: "$U",
        symbolNative: "$",
        minorSingle: "Centésimo",
        minorPlural: "Centésimos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.UZBEKISTANI_SOM]: {
        countryCode: "UZ",
        name: "Uzbekistani Som",
        demonym: "Uzbekistani",
        majorSingle: "Som",
        majorPlural: "Som",
        ISOnum: 860,
        symbol: "сум",
        symbolNative: "сум",
        minorSingle: "Tiyin",
        minorPlural: "Tiyin",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.VENEZUELAN_BOLIVAR_DIGITAL]: {
        countryCode: "VE",
        name: "Venezuelan bolívar digital",
        demonym: "Venezuelan",
        majorSingle: "Bolívar Digital",
        majorPlural: "Bolívars Digital",
        ISOnum: null,
        symbol: "Bs.",
        symbolNative: "Bs.",
        minorSingle: "Céntimo",
        minorPlural: "Céntimos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.VENEZUELAN_BOLIVAR_SOBERANO]: {
        countryCode: "VE",
        name: "Venezuelan Bolívar Soberano",
        demonym: "Venezuelan",
        majorSingle: "Bolívar",
        majorPlural: "Bolívares",
        ISOnum: 928,
        symbol: "Bs.F",
        symbolNative: "Bs.F",
        minorSingle: "Centimo",
        minorPlural: "Centimos",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.VIETNAMESE_DONG]: {
        countryCode: "VN",
        name: "Vietnamese Dong",
        demonym: "Vietnamese",
        majorSingle: "Dong",
        majorPlural: "Dong",
        ISOnum: 704,
        symbol: "₫",
        symbolNative: "₫",
        minorSingle: "Hào",
        minorPlural: "Hào",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 10,
    },
    [CurrencyCodes.VANUATU_VATU]: {
        countryCode: "VU",
        name: "Vanuatu Vatu",
        demonym: "Vanuatu",
        majorSingle: "Vatu",
        majorPlural: "Vatu",
        ISOnum: 548,
        symbol: "VT",
        symbolNative: "VT",
        minorSingle: "",
        minorPlural: "",
        ISOdigits: 0,
        decimals: 0,
        numToBasic: null,
    },
    [CurrencyCodes.SAMOAN_TALA]: {
        countryCode: "WS",
        name: "Samoan Tala",
        demonym: "Samoan",
        majorSingle: "Tala",
        majorPlural: "Tala",
        ISOnum: 882,
        symbol: "T",
        symbolNative: "ST",
        minorSingle: "Sene",
        minorPlural: "Sene",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CENTRAL_AFRICAN_FRANC]: {
        countryCode: "CF",
        name: "Central African CFA Franc BEAC",
        demonym: "Central African CFA",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 950,
        symbol: "Fr",
        symbolNative: "Fr.",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.EAST_CARIBBEAN_DOLLAR]: {
        countryCode: "GD",
        name: "East Caribbean Dollar",
        demonym: "East Caribbean",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 951,
        symbol: "$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.WEST_AFRICAN_FRANC]: {
        countryCode: "BJ",
        name: "West African CFA Franc BCEAO",
        demonym: "West African CFA",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 952,
        symbol: "₣",
        symbolNative: "₣",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 0,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.CFP_FRANC]: {
        countryCode: "PF",
        name: "CFP Franc (Franc Pacifique)",
        demonym: "CFP",
        majorSingle: "Franc",
        majorPlural: "Francs",
        ISOnum: 953,
        symbol: "₣",
        symbolNative: "₣",
        minorSingle: "Centime",
        minorPlural: "Centimes",
        ISOdigits: 0,
        decimals: 0,
        numToBasic: 100,
    },
    [CurrencyCodes.YEMENI_RIAL]: {
        countryCode: "YE",
        name: "Yemeni Rial",
        demonym: "Yemeni",
        majorSingle: "Rial",
        majorPlural: "Rials",
        ISOnum: 886,
        symbol: "YR",
        symbolNative: "ر.ي.",
        minorSingle: "Fils",
        minorPlural: "Fils",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.SOUTH_AFRICAN_RAND]: {
        countryCode: "ZA",
        name: "South African Rand",
        demonym: "South African",
        majorSingle: "Rand",
        majorPlural: "Rand",
        ISOnum: 710,
        symbol: "R",
        symbolNative: "R",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ZAMBIAN_KWACHA]: {
        countryCode: "ZM",
        name: "Zambian Kwacha",
        demonym: "Zambian",
        majorSingle: "Kwacha",
        majorPlural: "Kwacha",
        ISOnum: 967,
        symbol: "ZK",
        symbolNative: "ZK",
        minorSingle: "Ngwee",
        minorPlural: "Ngwee",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    },
    [CurrencyCodes.ZIMBABWEAN_DOLLAR]: {
        countryCode: "ZW",
        name: "Zimbabwean Dollar",
        demonym: "Zimbabwean",
        majorSingle: "Dollar",
        majorPlural: "Dollars",
        ISOnum: 932,
        symbol: "Z$",
        symbolNative: "$",
        minorSingle: "Cent",
        minorPlural: "Cents",
        ISOdigits: 2,
        decimals: 2,
        numToBasic: 100,
    }
};
